export enum Type {
  LOAD = 'app/template-wizard/LOAD',
  TEMPLATE_SELECT = 'app/template-wizard/TEMPLATE_SELECT',
  UNLOAD = 'app/template-wizard/UNLOAD',
}
